import React from 'react'
import Typestack from '../../../typestack'
import { Icon } from '../../../../shared/tr-icons'
import PrimaryButton from '../../../primary-button/PrimaryButton'

import {HeaderSearchHead, HeaderSearchClose, HeaderSearchFoot, HeaderSearchBody, HeaderSearchFootButton, HeaderSearchFootLink, HeaderSearchInput, HeaderSearchIcon, HeaderSearchMobileWrapper} from './HeaderSearchMobile.styles'

const HeaderSearchMobileComponent = ({events, search, i18n}) => {
  return (
    <HeaderSearchMobileWrapper>
      <HeaderSearchHead>
        <Typestack type='heading' size='md' weight='black'>{i18n.search}</Typestack>
        <HeaderSearchClose onClick={events.handleCloseClick}>
          <Icon
            path="./icons/ui/black/close.svg"
            size="s"
          />
        </HeaderSearchClose>
      </HeaderSearchHead>
      
      <HeaderSearchBody>
        <HeaderSearchInput type='text' defaultValue={search} onChange={events.handleChange} placeholder='Search table' />
        <HeaderSearchIcon>
          <Icon
            path="./icons/ui/black/search.svg"
            size="s"
          />
        </HeaderSearchIcon>
      </HeaderSearchBody>

      <HeaderSearchFoot>
        <HeaderSearchFootLink onClick={events.handleCloseClick}>{i18n.cancel}</HeaderSearchFootLink>
        <HeaderSearchFootButton onClick={events.handleApply}>{i18n.apply}</HeaderSearchFootButton>
      </HeaderSearchFoot>
    </HeaderSearchMobileWrapper>
  )
}

export default HeaderSearchMobileComponent
